define('viewmodels/pages/cash/deposit/cancelWithdrawal',['underscore', 'knockout', 'bluebird'], function (_, ko, Promise) {

    function CancelWithdrawalViewModel(
        navigation,
        TransactionListViewModel,
        getDepositField,
        showError,
        pendingWithdrawals)
    {
        this.transactionsList = new TransactionListViewModel(pendingWithdrawals);

        this.cancelAll = function () {
            var promises = _.map(pendingWithdrawals(), function (pendingWithdrawal) {
                return pendingWithdrawal.cancel();
            });

            return Promise.all(promises).then(function () {
                navigation.navigate(navigation.ROUTES.GAMES);
            }).catch(function () {
                showError(
                    getDepositField('cancelling_withdrawal_failed_error_message'),
                    getDepositField('cancelling_withdrawal_failed_error_title'));
            })
        };

        this.title = getDepositField('cancel_pending_withdrawals_title');
        this.cancelAllWithdrawalsButtonText = getDepositField('cancel_all_withdrawals_button_text');
        this.ignorePendingWithdrawalsButtonText = getDepositField('ignore_pending_withdrawals_button_text');

        this.ignorePendingWithdrawals = ko.observable(false);
    }

    return CancelWithdrawalViewModel;

});

